"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var vuex_1 = require("vuex");
vuex_1.Store.prototype.history = function (historyKey) {
    throw new Error('The plugin has to be installed to be used!');
};
__export(require("./HistorySnapshot"));
__export(require("./VuexHistory"));
__export(require("./VuexMultiHistory"));
__export(require("./errors/BaseError"));
__export(require("./errors/InvalidTypeError"));
__export(require("./errors/InvalidValueError"));
__export(require("./errors/InvalidOptionsError"));
